"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentStatus = void 0;
var DocumentStatus;
(function (DocumentStatus) {
    DocumentStatus["NEW"] = "NEW";
    DocumentStatus["IN_PROGRESS"] = "IN_PROGRESS";
    DocumentStatus["SUBMITTED"] = "SUBMITTED";
    DocumentStatus["DELETED"] = "DELETED";
    DocumentStatus["NA"] = "NA";
})(DocumentStatus = exports.DocumentStatus || (exports.DocumentStatus = {}));
//# sourceMappingURL=documentStatus.js.map